import {
  Component,
  OnInit,
  Optional,
  Inject,
  Output,
  EventEmitter,
  HostListener,
} from '@angular/core';
import { QuickQuoteService } from '../../services/quickquote-service.service';
import { switchMap, debounceTime } from 'rxjs/operators';
import { FormBuilder, FormControl } from '@angular/forms';
import moment_ from 'moment-timezone';
const moment = moment_;
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { QuickQuoteCardComponent } from '../QuickQuoteDialog/quick-quote-dialog.component';

@Component({
  selector: 'quick-quote-search',
  templateUrl: './quick-quote-search.component.html',
})
export class QuickQuoteFormInputComponent implements OnInit {
  filteredSymbols: any[] = [];
  delay: any;
  invalidSymbol: boolean = false;
  showSearchPrompt: boolean = true;
  isLoading: boolean = false;
  @Output() showSearchPromptEvent = new EventEmitter<boolean>();
  formControl = new FormControl('');

  constructor(
    public fb: FormBuilder,
    public QuickQuoteService: QuickQuoteService,
    @Optional() @Inject('AppSettings') appSettings: any,
    public dialog: MatDialog
  ) {
    if (appSettings.isAdvisor) {
      this.delay = 2000;
    } else {
      this.delay = 100;
    }
  }

  ngOnInit() {
    this.formControl.valueChanges
      .pipe(
        debounceTime(this.delay),
        switchMap((value) => {
          this.isLoading = true;
          this.invalidSymbol = false;
          return this.QuickQuoteService.getModSymbolLookupResponse(value);
        })
      )
      .subscribe((symbols) => {
        this.filteredSymbols = symbols;
        if (this.filteredSymbols == null || this.filteredSymbols.length === 0) {
          this.invalidSymbol = true;
        }
        this.isLoading = false;
      });
  }

  sendShowSearchPromptValue() {
    this.showSearchPromptEvent.emit(this.showSearchPrompt);
  }

  onClose() {
    this.formControl.setValue('');
    this.showSearchPrompt = false;
    this.filteredSymbols = [];
    this.isLoading = false;
    this.invalidSymbol = false;
    this.sendShowSearchPromptValue();
  }

  openQuoteDialog(symbol: string) {
    this.formControl.setValue('');
    this.showSearchPrompt = false;
    this.isLoading = false;
    this.sendShowSearchPromptValue();
    this.dialog.open(QuickQuoteCardComponent, {
      data: {
        symbol: symbol,
        invalidSymbol: this.invalidSymbol,
      },
      hasBackdrop: true,
      width: '400px',
    });
    this.filteredSymbols = [];
  }

  @HostListener('document:click', ['$event']) onClick(event: any) {
    let element = event.target;
    while (element) {
      if (element.id === 'quick-quote-search') {
        return;
      }
      element = element.parentElement;
    }
    this.formControl.setValue('');
  }
}
